<template>

<div class="DataUpdate">
  <va-notification
    v-if="addRExito"
    color="success"
    class="refNoData"
  >
    Se creó el convenio con éxito
  </va-notification>

  <va-notification
    v-if="refNoUpdate"
    color="danger"
    class="refNoData"
  >
    La actualización del programa presentó un fallo.
  </va-notification>

  <va-notification
    v-if="refWSUpdate"
    color="danger"
    class="refNoData"
  >
    El servicio que ejecuta la actualización no se encuentra activo.
  </va-notification>
  <ValidationObserver ref="obsFieldsSearch">

    <FormSearchProgram
      :FieldsForm="formSearch"
      :ModelForm="formSchModel"
      :method="executeProcess"
    />

  </ValidationObserver>

  <div class="adminCard">
    <div class="adminCardHeader">
      Operador - Programas
    </div>
    <div class="adminCardBody">
      <div class="adminFormGrid">
        <div class="adminField">
          <label>Operador</label>
          <multiselect
            v-model="value"
            :options="options"
            :custom-label="nameWithLang"
            placeholder="Selecciona operador"
            label="value"
            track-by="id"
            @input="GetProgramByOperators"
          />
        </div>
        <div class="adminField">
          <label>Programas IBERO</label>
          <multiselect
            v-model="value2"
            :options="options2"
            placeholder="Seleccionar programas"
            label="value"
            track-by="id"
            :multiple="true"
            :taggable="true"
            @tag="addTag"
          />
        </div>
      </div>
      <button
        class="btnPrimary"
        @click="AddProgram"
      >
        Guardar Programas
      </button>


      <va-notification
        v-if="Operatornull"
        color="danger"
        class="refNoData"
      >
        Por favor ingrese un operador y/o programa para continuar
      </va-notification>
    </div>
  </div>
  <div class="adminTable">
    <b-table
      striped
      hover
      responsive="sm"
      selectable
      ref="selectableTable"
      :items="items"
      :fields="fields"
      @row-selected="onRowSelected"
    />
  </div>

  <va-notification
    v-if="okDelete"
    color="primary"
    class="refNoData"
  >
    Se eliminó correctamente el operador-programa
  </va-notification>

  <b-modal
    ref="my-modal"
    title="Administrador de operadores"
    hide-footer
  >
    <div class="modalBody">
      <h5>
        ¿Deseas eliminar el programa operador?
      </h5>

      <div class="modalActions">

        <button
          class="btnDanger"
          @click="hideModal"
        >
          Aceptar
        </button>

        <button
          class="btnCancel"
          @click="toggleModal"
        >
          Cancelar
        </button>
      </div>
    </div>
  </b-modal>
</div>
</template>
<script>
// eslint-disable-next-line import/no-duplicates
import FormSearchProgram from '@/components/forms/Forms.vue'
// eslint-disable-next-line import/no-duplicates
import FormupdatePeriods from '@/components/forms/Forms.vue'
import IberoHelpers from '@/store/helpers.js'
import DataTablePrograms from '@/components/data-tables/DataPeriod.vue'
import Multiselect from 'vue-multiselect'

export default {
  name: 'DataUpdate',
  components: {
    DataTablePrograms,
    FormSearchProgram,
    FormupdatePeriods,
    Multiselect,
  },
  data () {
    return {
      // Solo data multiselect
      selected: null,
      idProgra: [],
      value: [],
      value2: [],
      addRExito: false,
      UpdRExito: false,
      refNoUpdate: false,
      refWSUpdate: false,
      Operatornull: false,
      okDelete: false,
      DeleteProg: true,
      programoperator: '',
      seccionvalid: '',

      OperatorProgramL: IberoHelpers.OperatorProgramList(this.$store),
      ProgramList: IberoHelpers.getPrograms2(this.$store),

      options: this.$store.state.PermanenceList,
      options2: this.$store.state.ProgramList,

      formSchModel: { textvalue: '' },
      OperatorSearch: { Id_Operator: '' },
      IDPROGRAM: [],
      PROGRAM: [],
      CODPROGRAM: [],
      Id_OperatorProgram: [],

      // se crea la tabla dinamica con los programas

      fields: [
        {
          key: 'PROGRAM',
          label: 'PROGRAMA IBERO',
          sortable: true,
        },
        {
          key: 'CODPROGRAM',
          label: 'CODIGO PROGRAMA',
          sortable: false,
        },
        {
          key: 'OPERADOR',
          label: 'OPERADOR',
          sortable: true,

        },
        {
          key: 'DeleteRow',
          label: '',
          sortable: true,
          variant: 'primary',
        },
      ],
      items: [],
      DLPrograms: [],
      renderComponent1: false,
    }
  },
  methods: {

    AddProgram: function () {
      debugger

      this.items = ''
      if (this.value.length === 0 || this.value2.length === 0 || this.value === null || this.value2 === null) {
        this.Operatornull = true
        return 'error en operador'
      }

      this.Operatornull = false
      for (let index = 0; index < this.value2.length; index++) {
        this.idProgra[index] = this.value2[index].id.toString()
      }
      this.formSchModel.textvalue = '{"reference":"3","id_Operator":' + (this.value.id).toString() + ',"id_Program":[' + this.idProgra + ']}'
      var totalinf = IberoHelpers.addOperatorProgram(
        this.$store,
        this.formSchModel
      )
      this.value = ''
      this.value2 = ''
      debugger
      totalinf.then((Response) => {
        this.renderComponent1 = false
        if (Response === false) {
          this.refWSUpdate = true
        } else if (!(Response.status === 200)) {
          this.refNoUpdate = true
        } else {
          this.addRExito = true
        }
        this.$modal.hide('ProgramModal')
        this.Operatornull = false
        this.okDelete = false
        this.DeleteProg = true
      })
    },

    showoperators () {
      this.items = ''
      var totalinf = IberoHelpers.getprogramByOperator(
        this.$store,
        this.value.id
      )
      totalinf.then((Response) => {
        this.renderComponent1 = false
        if (Response === false) {
          // this.refWSUpdate = true
        } else if (!(Response.status === 200)) {
          // this.refNoUpdate = true
        } else {
          debugger
          this.items = Response.data

          for (let index = 0; index < this.items.length; index++) {
            var stringboton = 'x'
            this.items[index].DeleteRow = stringboton
          }
          // this.value2 = ''
        }
      })
    },

    GetProgramByOperators: function () {
      debugger
      this.items = ''
      if (this.seccionvalid === '1') {
        this.seccionvalid = ''
        return 'error'
      }
      if (this.value.length === 0 || this.value === null) {
        this.Operatornull = true
        return 'error en operador'
      }
      this.Operatornull = false
      this.OperatorSearch.Id_Operator = this.value.id
      var totalinf = IberoHelpers.getprogramByOperator(
        this.$store,
        this.value.id
      )

      totalinf.then((Response) => {
        this.renderComponent1 = false
        if (Response === false) {
          this.refWSUpdate = true
        } else if (!(Response.status === 200)) {
          this.refNoUpdate = true
        } else {
          debugger
          this.items = Response.data

          for (let index = 0; index < this.items.length; index++) {
            var stringboton = 'x'
            this.items[index].DeleteRow = stringboton
          }

          this.value2 = ''
        }
        this.$modal.hide('ProgramModal')
        this.addRExito = false
      })
    },
    onRowSelected (items) {
      debugger
      if (this.seccionvalid === '1') {
        this.seccionvalid = ''
        return 'error'
      }
      this.$refs['my-modal'].show()
      this.programoperator = items[0].Id_OperatorProgram
    },
    hideModal (items) {
      debugger

      this.seccionvalid = ''
      this.$refs['my-modal'].hide()
      this.formSchModel.textvalue = '{"reference":"4","id_Operator":' + '1' + ',"id_Program":[' + '1' + '], "IDOPERATOPROGRAM":' + this.programoperator + '}'

      var totalinf = IberoHelpers.addOperatorProgram(
        this.$store,
        this.formSchModel
      )
      this.value = ''
      this.value2 = ''
      this.seccionvalid = '1'
      this.DLPrograms = totalinf
      this.showoperators()
    },
    toggleModal (items) {
      // We pass the ID of the button that we want to return focus to
      // when the modal has hidden
      this.$refs['my-modal'].toggle('#toggle-btn')
      this.DeleteProg = false
      this.$refs['my-modal'].hide()
    },

    processData: function (dataInf, refdata) {
      this.limpiaref()
      this.isNew = false
      this.formUpdModel.desPeriod = dataInf.desPeriod
      if (dataInf.staActive === true) { this.formUpdModel.staActive = 1 } else { this.formUpdModel.staActive = 0 }
      this.formUpdModel.datStartDate = dataInf.datStartDate
      this.formUpdModel.datEndDate = dataInf.datEndDate
      this.formUpdModel.dat_StrartInscription = dataInf.dat_StrartInscription
      this.formUpdModel.dat_EndInscription = dataInf.dat_EndInscription
      IberoHelpers.forceRerender2(this)
      this.$modal.show('ProgramModal')
    },
  },
}
</script>